import { CalendarRef } from '@griply/types';
import { getDefaultCalendarWrites } from '@griply/utils';
import { useCallback } from 'react';
import { useUpdateExternalConnectionMutation } from 'shared/hooks/queries/use-update-external-connection-mutation';

import { useExternalCalendarConnections } from './use-external-calendar-connections';

export const useSetDefaultCalendar = () => {
  const { mutate } = useUpdateExternalConnectionMutation();
  const connections = useExternalCalendarConnections();

  return useCallback(
    (next: CalendarRef) => {
      getDefaultCalendarWrites(connections, next).forEach(
        ({ connectionId, defaultCalendar }) => {
          mutate({ id: connectionId, settings: { defaultCalendar } });
        },
      );
    },
    [connections, mutate],
  );
};
